export enum SUPPORTED_CURRENCY {
  EUR = 'EUR',
  GBP = 'GBP',
  CHF = 'CHF',
}

export type SupportedCurrency =
  (typeof SUPPORTED_CURRENCY)[keyof typeof SUPPORTED_CURRENCY];
